import useAuth from './useAuth';

export const useGuard = () => {
   const { permissions, roles } = useAuth();

   const hasPermission = (permission: string) => {
      return permissions.some((p) => permission.includes(p.name));
   };

   const hasRole = (role: string) => {
      return roles.some((r) => role.includes(r.name));
   };

   return {
      hasPermission,
      hasRole,
   };
};
